export enum FileTypes {
  CSV = 'csv',
  PDF = 'pdf',
  EML = 'eml'
}
